{
  "loading": "טוען...",
  "placeholder": "בחר…"
}
